import styled from 'styled-components/macro';

export const ArrowContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: ${({ className }) =>
    className.includes('slick-disabled') ? 'none' : 'default'} !important;
`;
